import {
    FormSelectAccount,
    FormSelectRole,
    FormSingleDatePicker,
    IDynamicFormGroup,
} from '@src/components';
import { TFunction } from 'i18next';

type UserFilterSchemaProps = {
    t: TFunction;
    accountId?: string;
    onAccountChange?: (
        value: { label: string; value: string } | null | undefined
    ) => void;
};

export function userFilterSchema({
    t,
    accountId,
    onAccountChange,
}: UserFilterSchemaProps): IDynamicFormGroup[] {
    return [
        {
            title: '',
            showDivider: true,
            formRows: [
                {
                    label: t('forms.account'),
                    keyName: 'account',
                    Component: FormSelectAccount,
                    registerOptions: {
                        onChange: (e) => {
                            const value = e?.target?.value;
                            const accountValue =
                                value &&
                                typeof value === 'object' &&
                                value.value
                                    ? value
                                    : value || null;
                            onAccountChange?.(accountValue);
                        },
                    },
                    formProps: {
                        allowClear: true,
                    },
                },
            ],
        },
        {
            title: '',
            showDivider: true,
            formRows: [
                {
                    label: t('forms.role'),
                    keyName: 'role',
                    Component: FormSelectRole,
                    formProps: {
                        size: 'large',
                        requireAccountId: true,
                        accountId: accountId,
                        allowClear: true,
                    },
                },
            ],
        },
        {
            title: t('forms.addedDate'),
            showDivider: true,
            className: 'grid grid-cols-2 gap-4',
            formRows: [
                {
                    label: t('forms.from'),
                    keyName: 'createdAtStart',
                    Component: FormSingleDatePicker,
                    formProps: {
                        size: 'large',
                        allowClear: true,
                    },
                },
                {
                    label: t('forms.to'),
                    keyName: 'createdAtEnd',
                    Component: FormSingleDatePicker,
                    registerOptions: {
                        validate: (value, formValues) => {
                            const startDate = formValues?.createdAtStart;
                            if (
                                startDate &&
                                value &&
                                value.isBefore(startDate, 'day')
                            ) {
                                return t('errors.formErrors.rangeInvalid', {
                                    startLabel: t('forms.from'),
                                    endLabel: t('forms.to'),
                                });
                            }
                            return true;
                        },
                    },
                    formProps: {
                        size: 'large',
                        allowClear: true,
                    },
                },
            ],
        },
    ];
}
